<template>
  <v-app id="inspire">
    <!-- <div v-if="this.logged === true"> -->
    <toolbar-menu v-if="this.logged === true"></toolbar-menu>
    <v-content>
      <transition name="slide">
        <router-view/>
      </transition>
    </v-content>
    <footer-menu v-if="this.logged === true"></footer-menu>

    <MigrationDialog></MigrationDialog>
  </v-app>
</template>

<script>
  import ToolbarMenu from './components/layout/Toolbar.vue'
  import FooterMenu from './components/layout/Footer.vue'

  import AuthLogin from '@/views/auth/Login.vue'

  import MigrationDialog from '@/components/migrationDialog/index'

  import store from './store'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      ToolbarMenu,
      FooterMenu,
      AuthLogin,
      MigrationDialog
    },
    data () {
      return {
        show: false,
        isMobile: false,
        isTablet: false
      }
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      this.homeScreen()
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    computed: {
      logged () {
        return this.$store.state.auth.auth.isLogged
      },
      ...mapGetters('auth', ['getUser'])
    },
    methods: {
      homeScreen () {
        window.console.log('homeScreen')
        window.addEventListener('beforeinstallprompt', (e) => {
          // beforeinstallprompt Event fired
          // e.userChoice will return a Promise.
          // For more details read: https://developers.google.com/web/fundamentals/getting-started/primers/promises
          e.userChoice.then((choiceResult) => {
            if (process.env.NODE_ENV !== 'production') console.log(choiceResult.outcome)
            if (choiceResult.outcome === 'dismissed') {
              console.log('User cancelled home screen install')
            } else {
              console.log('User added to home screen')
            }
          })
        })
      },
      onResize () {
        // this.isMobile = window.innerWidth < 600
        if ((window.innerWidth < 600)) {
          this.isMobile = true
          this.isTablet = false
        } else if ((window.innerWidth > 600) && (window.innerWidth < 960)) {
          this.isMobile = false
          this.isTablet = true
        } else if ((window.innerWidth > 960)) {
          this.isTablet = false
          this.isMobile = false
        }
        store.dispatch('app/setDevice', { mobile: this.isMobile, tablet: this.isTablet }).then(() => {
          // console.log()
        }).catch(error => {
          console.log(error)
        })
      }
    },
    name: 'App'
  }
</script>

<style>
  a:link
  {
    text-decoration:none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue